import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modern-error-modal',
    templateUrl: './modern-error-modal.component.html',
    styleUrls: ['./modern-error-modal.component.scss'],
    standalone: false
})
export class ModernErrorModalComponent {

  @Input() title: string = 'Error de Validación';
  @Input() message: string = '';
  @Input() details: string = '';
  @Input() type: 'error' | 'warning' | 'info' = 'error';
  @Input() showTwoButtons: boolean = false; // Para mostrar dos botones en advertencias

  constructor(private activeModal: NgbActiveModal) { }

  close() {
    this.activeModal.close();
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  confirm() {
    this.activeModal.close('confirm');
  }

  getIconClass(): string {
    switch (this.type) {
      case 'error': return 'fas fa-exclamation-circle text-danger';
      case 'warning': return 'fas fa-exclamation-triangle text-warning';
      case 'info': return 'fas fa-info-circle text-info';
      default: return 'fas fa-exclamation-circle text-danger';
    }
  }

  getHeaderClass(): string {
    switch (this.type) {
      case 'error': return 'border-danger';
      case 'warning': return 'border-warning';
      case 'info': return 'border-info';
      default: return 'border-danger';
    }
  }
}
